import { render, staticRenderFns } from "./apprReq.vue?vue&type=template&id=3ba6307e"
import script from "./apprReq.vue?vue&type=script&lang=js"
export * from "./apprReq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ba6307e')) {
      api.createRecord('3ba6307e', component.options)
    } else {
      api.reload('3ba6307e', component.options)
    }
    module.hot.accept("./apprReq.vue?vue&type=template&id=3ba6307e", function () {
      api.rerender('3ba6307e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sys/appr/doc/apprReq.vue"
export default component.exports